import {
    DrillPath,
    ViewDataRange,
    ViewEvaluationRange,
    ViewRow,
    WpDisplayConfig,
    WpViewTable,
} from '../core';
import { Sort, SortOrder } from '../grid';

import { ColumnId } from './model/column-id.model';

export interface MainState {
    pending: {
        reload?: boolean;
        reset?: boolean;
    };
    config?: WpDisplayConfig;
    table?: WpViewTable;
    dataRanges?: ViewDataRange[];
    selectedDataRangeId?: number;
    evalRanges?: ViewEvaluationRange[];
    selectedEvalRangeId?: number;
    drillPaths?: DrillPath[];
    selectedDrillPathId?: string;
    period?: {
        start: Date;
        end: Date;
        createdOn: Date;
    };
    hasData?: boolean;
    rows?: ViewRow[];
    sortOptions?: Sort;
    otherRows?: any[];
}

export const defaultState = (): MainState => ({
    pending: {},
    sortOptions: {
        columnId: ColumnId.WINNING_PERCENTAGE,
        order: SortOrder.DESC,
    },
});
